import { defineNotificationCategory, extractRelativeActionUrl } from './types';

export const demandFrameworkChangedDescriptor = defineNotificationCategory(
  'demand_framework_changed',
  {
    actionUrl: (_data, organizationId) => `/org-id/${organizationId}/intake/demands`,
    pills: () => ['Demand Views'],
  },
);

export const demandReviewerAssignedDescriptor = defineNotificationCategory(
  'demand_reviewer_assigned',
  {
    actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
    pills: () => ['Demand Views'],
  },
);

export const demandStageChangedDescriptor = defineNotificationCategory('demand_stage_changed', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Demand Views'],
});
